
export type NeighborhoodsDisplayLevels = 'clusters' | 'markers';

const NeighborhoodsDisplayLevelsMap: Record<NeighborhoodsDisplayLevels, number> = {
    'clusters': 1,
    'markers': 3
};

export default NeighborhoodsDisplayLevelsMap;